import React, { useState, useEffect } from 'react';
import {
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  Flex
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

const UserSearchBox = ({ onSearch, initialQuery = '' }) => {
  const [query, setQuery] = useState(initialQuery);
  
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ query: query, page: 1 });
  };
  
  return (
    <form onSubmit={handleSubmit}>
      <Flex gap={2} align="center" mb={3}>
        <InputGroup flex="1" size="sm">
          <InputLeftElement pointerEvents="none" display="flex" alignItems="center" justifyContent="center">
            <SearchIcon color="#F6E05E" boxSize="14px" />
          </InputLeftElement>
          <Input
            placeholder="Search by Burrower ID or Bio..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            bg="whiteAlpha.50"
            border="1px solid"
            borderColor="whiteAlpha.200"
            borderRadius="full"
            _hover={{ borderColor: 'whiteAlpha.300' }}
            _focus={{ borderColor: '#F6E05E', boxShadow: '0 0 0 1px #F6E05E' }}
            _placeholder={{ color: 'gray.500', fontSize: 'xs' }}
            color="white"
            fontSize="sm"
          />
        </InputGroup>
        <Button
          type="submit"
          size="sm"
          borderRadius="full"
          bg="whiteAlpha.100"
          color="gray.300"
          fontSize="xs"
          fontWeight={600}
          px={4}
          _hover={{ bg: 'whiteAlpha.200', color: 'white' }}
          _active={{ bg: 'whiteAlpha.300' }}
        >
          Search
        </Button>
      </Flex>
    </form>
  );
};

export default UserSearchBox;
